import styled from 'styled-components';

export const DesiccantDetailsViewContainer = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  width: 100%;
  padding: ${({ theme: { token } }) => token.paddingXL}px ${({ theme: { token } }) => token.paddingMD}px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 33%;
  }
`;
